import { Directive, TemplateRef } from '@angular/core';

@Directive({selector: '[appQueryEntity]'})
export class QueryEntityDirective {
  constructor(public template: TemplateRef<any>) {}
}
